import React from 'react';
import { element, oneOfType, arrayOf, bool, shape, string } from 'prop-types';
import WithErrorContext from './withErrorContext';
import WithEmptyContext from './withEmptyContext';

// @deprecate
const EmptyWrapper = ({
  children,
  empty,
  error,
  notFoundMessage,
  reasons,
  className,
  errorMessage,
}) => (
  <WithErrorContext message={errorMessage} error={error}>
    <WithEmptyContext
      className={className}
      message={notFoundMessage}
      empty={empty}
      reasons={reasons}
    >
      {children}
    </WithEmptyContext>
  </WithErrorContext>
);

export const propTypes = {
  children: oneOfType([element, arrayOf(element)]).isRequired,
  empty: bool.isRequired,
  notFoundMessage: element,
  errorMessage: element,
  reasons: oneOfType([arrayOf(element), element]),
  error: oneOfType([shape(), bool]),
  className: oneOfType([shape(), string]),
};

export const defaultProps = {
  error: undefined,
  notFoundMessage: undefined,
  reasons: undefined,
  className: undefined,
  errorMessage: undefined,
};

EmptyWrapper.propTypes = propTypes;
EmptyWrapper.defaultProps = defaultProps;

export default EmptyWrapper;
